import {initClient} from '@dudagroup/editor'
import {createEditorConfig} from './config/config'
import './i18n'

import * as Sentry from '@sentry/react'
import 'rsuite/styles/index.less'
import '@dudagroup/editor/src/client/global.less'
import '@dudagroup/editor/src/client/atoms/toolbar.less'
import '@dudagroup/editor/src/client/blocks/richTextBlock/toolbar/tableMenu.less'
import './pickerMenu.less'

const settings = document.getElementById('settings')

if (!settings?.textContent) {
  throw new Error('Settings element not found in the document.')
}

const {sentryRelease, isBridge} = JSON.parse(settings.textContent)
if (sentryRelease) {
  Sentry.init({
    dsn: 'https://9ec1643206374f8cbf0a7a44304b3423@o49061.ingest.sentry.io/5830375',
    // integrations: [new Integrations.BrowserTracing()],

    // Value between 0 and 1. Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production.
    tracesSampleRate: 0.1,
    release: 'editor@' + sentryRelease,
  })
}

const config = createEditorConfig(isBridge)

if (document.readyState !== 'loading') {
  initClient(config)
} else {
  document.addEventListener('DOMContentLoaded', () => {
    initClient(config)
  })
}
